var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-0",attrs:{"color":"transparent"}},[_c('v-card-title',{staticClass:"pb-2 text-body-2 lighttext--text"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-chevron-right")])],1),_c('v-card-text',{staticClass:"text-h6 font-weight-black"},[_vm._v(" "+_vm._s(_vm.stat)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }